type Listener = () => void;

let unauthorizedListener: Listener | null = null;

export const onUnauthorized = (listener: Listener) => {
  unauthorizedListener = listener;
  return () => {
    if (unauthorizedListener === listener) unauthorizedListener = null;
  };
};

export const emitUnauthorized = () => {
  try {
    unauthorizedListener && unauthorizedListener();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (_e) {
    // no-ops
  }
};

export default { onUnauthorized, emitUnauthorized };
